import { useQuery } from "@tanstack/react-query";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import { AdminShell } from "@/components/admin-shell";
import { LoginScreen } from "@/components/login-screen";
import { ADMIN_ME_QUERY_KEY } from "@/lib/admin-queries";
import { AdminApiError, adminApi } from "@/lib/api";

// Auth gate for the whole console: resolve the admin actor once, then render the
// shell around every child route. A 401 means "not authenticated" (password
// mode) → show the login screen; other failures are surfaced as a connection
// error rather than a silent blank.
function RootGate() {
  const meQuery = useQuery({ queryKey: ADMIN_ME_QUERY_KEY, queryFn: () => adminApi.me() });

  if (meQuery.isPending) {
    return (
      <div className="flex min-h-dvh items-center justify-center text-sm text-muted-foreground">
        Ładowanie…
      </div>
    );
  }

  if (meQuery.isError) {
    if (meQuery.error instanceof AdminApiError && meQuery.error.status === 401) {
      return <LoginScreen />;
    }
    return (
      <div className="flex min-h-dvh items-center justify-center px-4 text-center text-sm text-destructive">
        Nie udało się połączyć z API panelu.
      </div>
    );
  }

  return (
    <AdminShell actor={meQuery.data.actor}>
      <Outlet />
    </AdminShell>
  );
}

export const Route = createRootRoute({ component: RootGate });
